import { createClient, SearchOperation, searchRequestFactory } from '@infuse/api/common';
import { Token } from './model';

const client = createClient('/rest/tokens');

export const tokenPermissions = {
  SEARCH: 'cpms.search-tokens-specialised'
};

export const searchTokens: SearchOperation<Token> = searchRequestFactory<Token>(client, {
  pattern: '/search',
  permissionId: tokenPermissions.SEARCH
});
